import { Button, TextField } from "@material-ui/core";
import { Notification, ThemesContext, useNotify } from "react-admin";

import PropTypes from "prop-types";
import i18next from "src/locales";
import { useAuth } from "src/hooks/useAuth";
import { useState } from "react";

const LoginForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { handleLogin } = useAuth();

  const notify = useNotify();

  const submit = async (e) => {
    e.preventDefault();
    try {
     const login = await handleLogin(email, password);
      window.location.href = "/";
    } catch (error) {
      notify("Invalid email or password");
    }
  };

  return (
    <ThemesContext.Provider value={{
      darkTheme: { palette: { mode: 'dark' } },
      lightTheme: { palette: { mode: 'light' } },
    }}>
      <form onSubmit={submit} style={{ padding: "0 20px 20px 20px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 6,
            marginBottom: 20,
          }}
        >
          <img src="/logo_header.png" alt="logo" style={{height: 100}} />
        </div>

        <div>
          <TextField
            name="email"
            type="email"
            label={i18next.translate('resources.Login.fields.email')}
            style={{ width: "100%" }}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div>
          <TextField
            name="password"
            type="password"
            label={i18next.translate('resources.Login.fields.password')}
            style={{ width: "100%" }}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 20,
          }}
        >
          <Button color="primary" type="submit" onClick={submit}>
            {i18next.translate('resources.Login.fields.loginButton')}
          </Button>
        </div>
      </form>
      <Notification />
    </ThemesContext.Provider>
  );
};

LoginForm.propTypes = {
  authProvider: PropTypes.func,
  previousRoute: PropTypes.string,
};

const LoginWithTheme = (props: any) => <LoginForm {...props} />;

export default LoginWithTheme;
